import React,{useState,useEffect,useRef}from'react';

interface Props {
  placeholder?: string;
  onSearch: (query: string) => void;
  delay?: number;
  className?: string;
  value?: string;
}

export default function SearchBar({placeholder='Search...',onSearch,delay=300,className='',value=''}:Props){
  const [q,setQ]=useState(value);
  const timer=useRef<any>(null);
  const onSearchRef=useRef(onSearch);
  onSearchRef.current=onSearch;

  useEffect(()=>{
    if(timer.current) clearTimeout(timer.current);
    timer.current=setTimeout(()=>onSearchRef.current(q.trim()),delay);
    return()=>{if(timer.current)clearTimeout(timer.current);};
  },[q,delay]);

  return(
    <div className={`relative ${className}`}>
      <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"/>
      </svg>
      <input
        value={q}
        onChange={e=>setQ(e.target.value)}
        placeholder={placeholder}
        className="w-full pl-9 pr-9 py-2.5 border border-gray-200 rounded-xl text-sm focus:outline-none focus:border-[#015CA6] focus:ring-2 focus:ring-[#015CA6]/10 bg-white"
      />
      {q&&(
        <button onClick={()=>{setQ('');onSearch('');}} className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-400 hover:text-gray-600 text-xs">✕</button>
      )}
    </div>
  );
}

// Multi-field search utility
export function multiSearch(items:any[], query:string, fields:string[]): any[] {
  if(!query) return items;
  const q=query.toLowerCase();
  return items.filter(item=>
    fields.some(field=>{
      const val=field.split('.').reduce((o,k)=>o?.[k],item);
      return val!=null && String(val).toLowerCase().includes(q);
    })
  );
}
